import React, { useEffect, useState } from "react";
import API_URL from "../ServiceModule/Service";
import "./cart.css";
import squareIcon from "../Images/payment-square.svg";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Box,
  Typography,
  Stack,
  Divider,
  CircularProgress,
} from "@mui/material";
import { Square } from "@mui/icons-material";
import CustomButton from "../components/CustomButton";
import encryptJSON from "../ServiceModule/Encrypt";
import { isProdEnv } from "../ServiceModule/Service";
import { getToken } from "../LoginModule/LoginUtility";

function PaymentForm({ open, onClose, handleCompleteOrder, userId, eventId }) {
  const [card, setCard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [payLoading, setPayLoading] = useState(false);
  const token = getToken()

  useEffect(() => {
    async function initializeCard() {
      const payments = window.Square.payments(
        "sandbox-sq0idb-SpS9QDUDbhstDcvp46OBxw",
        "sandbox"
      );
      const card = await payments.card();
      setLoading(false)
      await card.attach("#card-container");
      setCard(card);
    }

    if (open) {
      initializeCard();
    }

    return () => {

      if (card) {
        card.detach();
      }
    };
  }, [open]);

  async function handlePayment() {
    try {
      setPayLoading(true);

      const tokenResult = await card.tokenize();

      if (!tokenResult || tokenResult.status !== "OK") {
        throw new Error("Tokenization failed. Please try again.");
      }

      const data = {
        sourceId: tokenResult.token,
        userId: userId,
        eventId: eventId
      };

      const encryptedPayload = encryptJSON(data, "FO" + tokenResult.token);
      let payloadJson = isProdEnv === "true"
        ? { element: encryptedPayload, token: tokenResult.token }
        : data;

      const response = await fetch(API_URL + "/api/order/process-payment", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "authorization": `Bearer ${token}`
        },
        body: JSON.stringify(payloadJson),
      });

      if (!response.ok) {
        throw new Error(`Payment API Error: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();

      if (result?.payment?.status === "COMPLETED") {
        handleCompleteOrder(result.payment.status, result.payment.id);
      } else {
        throw new Error(`Payment failed with status: ${result?.payment?.status || "UNKNOWN"}`);
      }
    } catch (error) {
      console.error("Payment error:", error.message);
      handleCompleteOrder(null, null);
    } finally {
      setPayLoading(false);
    }
  }


  return (
    <Dialog
      open={open}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "12px",
          padding: "10px",
        },
      }}
      maxWidth="xs"
      fullWidth
    >
      <Stack
        width={"100%"}
        padding={"10px"}
        spacing={2}
        border={"1px solid #D9D9D9"}
        borderRadius={"10px"}
        direction="column"
        alignItems="center"
        justifyContent="center"
      >
        <DialogTitle
          sx={{ textAlign: "center", width: "100%", padding: "0px" }}
        >
          <Box
            display={"flex"}
            bgcolor={"#1976d2"}
            justifyContent={"center"}
            alignItems={"center"}
            borderRadius={"10px"}
            padding={"5px 0px"}

          >
            <Box
              component="img"
              color={"secondary"}
              sx={{ height: 30, width: 30 }}
              alt="The house from the offer."
              src={squareIcon}
            />
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: "500",
                fontStyle: "italic",

                color: "white"
              }}
            >
              Square Payment
            </Typography>
          </Box>
          <Divider sx={{ width: "100%", height: "2px", borderColor: "#434343", margin: "10px 0px" }} />
          <Typography
            width={"100%"}
            padding={"0px"}
             variant="body1"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "12px",
            }}
          >
            Complete Your Payment
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ width: "100%", padding: "0px" }}>
          {loading ?
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="20px"
            >
              <CircularProgress style={{ height: '20px', width: '20px' }} />
            </Box>
            :
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="20px"
            >
            </Box>
          }
          <div
            id="card-container"
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxSizing: "border-box",
            }}
          ></div>
          <DialogActions
            sx={{ justifyContent: "center", width: "100%", padding: "0px", marginTop: loading ? '20px' : '0px' }}
          >
            <CustomButton
              text="Pay"
              size="lg"
              className="mt-2 py-1 px-3"
              block={true}
              onClick={handlePayment}
              style={{ width: '100%' }}
              onLoading={payLoading}
            />

            <CustomButton
              text='Cancel'
              size="lg"
              block={true}
              className="mt-2 py-1 px-3"
              bgcolor={"#000000"}
              colo={"#ffffff"}
              onClick={onClose}
              disabled={payLoading}
            />

          </DialogActions>
        </DialogContent>
      </Stack>
    </Dialog>
  );
}

export default PaymentForm;
